import React from 'react'

// bootstrap
import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router
import { Link } from 'react-router-dom';

// skeleton loading
import BlogsLodingSkeleton from './table__loadingSkeleton'

// tooltips
import { renderTooltipDelete, renderTooltipEdit } from '../tooltips/Blogs__Tooltips'

// react moment
import Moment from 'react-moment';

export default function BlogsTable(props) {

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    <th width={35}>
                        <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                            <input
                                type="checkbox"
                                className="d-none"
                                checked={props.allCheckboxSelected}
                                onChange={ev => props.handleSelectAllChange(ev)} />
                            <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                <FeatherIcon
                                    icon="check"
                                    size="11"
                                    className="icon position-relative" />
                            </span>
                        </label>
                    </th>
                    {
                        props.column__Title && (
                            <th>
                                <p className="text-capitalize">
                                    Title
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__Author && (
                            <th>
                                <p className="text-capitalize">
                                    Author
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__Status && (
                            <th>
                                <p className="text-capitalize">
                                    Status
                                </p>
                            </th>
                        )
                    }

                    
                    {
                        props.column__DateAdded && (
                            <th width="170">
                                <p className="text-capitalize">
                                    date added
                                </p>
                            </th>
                        )
                    }

                    <th width="90"></th>
                </tr>
            </thead>

            <tbody>
                {
                    /* loading */
                    props.loading && (
                        <React.Fragment>
                            {
                                (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <BlogsLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    )
                }

                {
                    /* EMAILS DATA */
                    (props.blogs && props.blogs.length) ? props.blogs.map(item => (
                        <tr key={item.blog_id}>
                            <td className="column__checkbox">
                                <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                    <input type="checkbox" className="d-none all-checkboxes-selector-checkbox" />
                                    <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                        <FeatherIcon
                                            icon="check"
                                            size="11"
                                            className="icon position-relative" />
                                    </span>
                                </label>
                            </td>

                            {
                                props.column__Title && (
                                    <td className="column__Title">
                                        <p className="">
                                            {item.title}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__Author && (
                                    <td className="column__Author">
                                        <p className="">
                                            {item.author_name}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__Status && (
                                    <td className="column__Status">
                                        <p className="">
                                            {item.status}
                                        </p>
                                    </td>
                                )
                            }

                            
                            {
                                props.column__DateAdded && (
                                    <td className="column__DateAdded">
                                        <p className="">
                                            <Moment
                                                format="MMMM DD, YYYY hh:mm a"
                                                date={item.date_added}
                                            />
                                        </p>
                                    </td>
                                )
                            }

                            <td className="column__actions">
                                <div className="d-flex justify-content-end">
                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipEdit}
                                    >
                                        <Link
                                            to={{
                                                pathname: '/blogs/edit/' + item.blog_id,
                                                state: { blogDetails: item }
                                            }}
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                        >
                                            <FeatherIcon
                                                icon="edit-2"
                                                size="15"
                                                className="icon" />
                                        </Link>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipDelete}
                                    >
                                        <button
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                            onClick={ev => props.handleDelete(ev, item.blog_id)}
                                        >
                                            <FeatherIcon
                                                icon="trash"
                                                size="15"
                                                className="icon" />
                                        </button>
                                    </OverlayTrigger>
                                </div>
                            </td>
                        </tr>
                    )) : (
                        !props.loading ? (
                            <tr>
                                <td colSpan="7">
                                    <p className="no-data-found text-center st-fw-700 py-1">
                                        No Data Found
                                    </p>
                                </td>
                            </tr>
                        ) : null
                    )
                }
            </tbody>
        </Table>
    )
}
